import { KnockStatus } from '@playcastdotio/Messaging';
import { Button, buttonVariants, Input } from '@playcastdotio/Shadcn';
import { useEffect, useState } from 'react';
import { Form, Link } from 'react-router-dom';
import { invitationState2, lobbyState, ruleState } from '../../../api/stores';
import { connectPeer } from '../../../api/api';
import clsx from 'clsx';

export const Queue = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  // const queueStatus = ['This queue is first come first serve', 'This queue prioritizes new players', 'you have 30 seconds to join'];

  const [knockStatus, setKnockStatus] = useState<KnockStatus | 'idle'>('pending');
  // const [showPhone, setShowPhone] = useState(false);
  const [joinButtonEnabled, setJoinButtonEnabled] = useState(false);
  const [queuePosition, setQueuePosition] = useState<number | undefined>(undefined);
  const [queuePositionText, setQueuePositionText] = useState('at an unknown position');
  const [showQueuePosition, setShowQueuePosition] = useState(false);
  const [queueDescription, setQueueDescription] = useState('');
  const [isRejected, setIsRejected] = useState(false);

  useEffect(() => {
    const lobbyListener = lobbyState.addListener((state) => {
      console.log('Lobby state:', state);
      if (state.accepted) {
        setJoinButtonEnabled(true);
        setKnockStatus('accepted');
        if (ruleState.currentState.autoJoinFromQueue) {
          connectPeer(lobbyState.currentState.broadcastHostId);
        }
      }
      if (state.rejected) {
        setIsRejected(true);
      }
      if (state.position) {
        setQueuePosition(state.position);
      }
    });
    const invitationListener = invitationState2.addListener((state) => {
      setQueueDescription(state.selectedInvite?.description || '');
    });
    if (lobbyState.currentState.position) {
      setQueuePosition(lobbyState.currentState.position);
    }
    setQueueDescription(invitationState2.currentState.selectedInvite?.description || '');
    return () => {
      lobbyState.removeListener(lobbyListener);
      invitationState2.removeListener(invitationListener);
    };
  }, []);

  useEffect(() => {
    if (!queuePosition) {
      return;
    }
    if (queuePosition === 1) {
      setQueuePositionText('1st');
    } else if (queuePosition === 2) {
      setQueuePositionText('2nd');
    } else if (queuePosition === 3) {
      setQueuePositionText('3rd');
    } else {
      setQueuePositionText(`${queuePosition}th`);
    }
    setShowQueuePosition(true);
  }, [queuePosition]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowQueuePosition(true);
    }, 2000);
    console.log('Timer started');
    return () => clearTimeout(timer);
  }, []);

  const handleContinue = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    console.log('Continue');
  };

  const handleJoinNow = () => {
    console.log('Join Now');
    // exchangeKnock();
  };

  return (
    <div className='bg-hero bg-content text-content-text m-0 h-screen w-full bg-cover bg-no-repeat p-0'>
      <div className='container mx-auto flex h-auto w-full flex-col items-center p-8'>
        <section id='hero' className='grid grid-cols-12 gap-x-4 gap-y-8'>
          <div className='col-span-full flex flex-grow flex-row items-center justify-center gap-x-2 pt-3 align-middle'>
            <img src='/images/playcast_logo-96x96.png' alt='Logo' className='h-12 w-12' />
            <h1 className='text-content-text-headline font-headline text-3xl font-bold md:pt-2'>
              <Link to='/'>Playcast</Link>
            </h1>
          </div>
        </section>
        {!isRejected ? (
          <>
            {ruleState.currentState.autoJoinFromQueue && knockStatus === 'accepted' ? (
              <span></span>
            ) : (
              <div className='mt-12 flex w-full justify-center'>
                <div className='bg-footer flex w-full flex-col items-center space-y-4 rounded-lg p-8 shadow-md sm:w-2/3 md:w-3/4 lg:w-2/6'>
                  <h2 className='row-auto -mt-4 text-2xl font-bold lg:text-3xl'>
                    {invitationState2.currentState.selectedInvite?.description}
                  </h2>
                  <h3 className='row-auto text-center text-xl font-semibold'>
                    {showQueuePosition ? (knockStatus === 'accepted' ? "It's all you!" : `You are ${queuePositionText} in lobby`) : ''}
                  </h3>
                  {!ruleState.currentState.autoJoinFromQueue && (
                    <Button disabled={!joinButtonEnabled} className='w-fit rounded-full' onClick={handleJoinNow}>
                      Join Now
                    </Button>
                  )}
                </div>
              </div>
            )}

            {/* {queuePositionText.includes('unknown') && (
              <div className='mt-8'>
                <Link to='https://playcast.io' className={clsx(buttonVariants(), 'max-w-48 text-wrap py-8 text-center')}>
                  Host Your Own Session on Playcast.io
                </Link>
              </div>
            )} */}

            {/* {showPhone && (
              <section className='flex w-full justify-center'>
                <div className='mt-8 flex w-full flex-col items-center justify-center space-y-4 text-center sm:w-2/3 md:w-3/4 lg:w-2/6'>
                  <h1 className='text-lg'>Get a notification when you are next in line</h1>
                  <div className='row-auto w-full'>
                    <Form onSubmit={handleContinue}>
                      <Input
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        type='text'
                        id='phoneNumber'
                        name='phoneNumber'
                        required
                        placeholder='Phone Number'
                        className='bg-content mb-2 h-auto w-full rounded border-none px-4 py-3 text-center text-lg shadow-sm'
                      />
                      <Button type='submit' className='rounded-full'>
                        Message Me
                      </Button>
                    </Form>
                  </div>
                  <div>
                    By providing my phone number, I hereby agree to and accept the{' '}
                    <Link to='/tos' className='text-blue-600 underline'>
                      Term of Service
                    </Link>{' '}
                    and{' '}
                    <Link to='/policy' className='text-blue-600 underline'>
                      Privacy Policy
                    </Link>{' '}
                    of Playcast, Inc.
                  </div>
                </div>
              </section>
            )} */}
          </>
        ) : (
          <div className='mt-8 flex flex-col items-center gap-14'>
            <div className='bg-footer w-full space-y-4 rounded-lg p-4 py-6 text-center shadow-md md:w-2/3 lg:w-2/5'>
              <h3 className='row-auto font-[Syne] text-2xl font-bold'>Lobby Update</h3>
              <p className='text-md row-auto text-center font-normal'>You have been removed from the lobby</p>
            </div>
            <div className='bg-footer w-full space-y-4 rounded-lg p-4 py-6 text-center shadow-md md:w-2/3 lg:w-2/5'>
              <h3 className='row-auto font-[Syne] text-2xl font-bold'>Want more Playcast?</h3>
              <p className='text-md row-auto text-center font-normal'>Set up your own Playcast now at Playcast.io</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
